export const loanTypes = [
  { value: 'DIRECT STAFFORD UNSUBSIDIZED', label: 'DIRECT STAFFORD UNSUBSIDIZED' },
  { value: 'DIRECT STAFFORD SUBSIDIZED', label: 'DIRECT STAFFORD SUBSIDIZED' },
  { value: 'FFEL STAFFORD SUBSIDIZED', label: 'FFEL STAFFORD SUBSIDIZED' },
  { value: 'FFEL STAFFORD UNSUBSIDIZED', label: 'FFEL STAFFORD UNSUBSIDIZED' },
  { value: 'FEDERAL PERKINS', label: 'FEDERAL PERKINS' },
  { value: 'DIRECT CONSOLIDATED UNSUBSIDIZED', label: 'DIRECT CONSOLIDATED UNSUBSIDIZED' },
  { value: 'DIRECT CONSOLIDATED SUBSIDIZED', label: 'DIRECT CONSOLIDATED SUBSIDIZED' },
  { value: 'DIRECT PLUS GRADUATE', label: 'DIRECT PLUS GRADUATE' },
  { value: 'FFEL CONSOLIDATED', label: 'FFEL CONSOLIDATED' },
  { value: '(LDS) LOANS FOR DISADVANTAGED STUDENTS', label: '(LDS) LOANS FOR DISADVANTAGED STUDENTS' },
  { value: '(HPSL) HEALTH PROFESSIONS STUDENT LOANS', label: '(HPSL) HEALTH PROFESSIONS STUDENT LOANS' },
]
export const urlRegex = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/\S*)?$/